import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '@shared/lib/utils';

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string | null;
  endAdornment?: ReactNode;
}

export function TextField({ label, error, endAdornment, className, id, ...rest }: TextFieldProps) {
  const inputId = id ?? label.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="mb-4">
      <label htmlFor={inputId} className="mb-1.5 block text-sm text-text-secondary">
        {label}
      </label>
      <div className="relative">
        <input
          id={inputId}
          className={cn(
            'w-full rounded-lg border bg-surface-2 px-3 py-2 text-sm text-text-primary outline-none transition-colors',
            'focus:border-accent',
            endAdornment && 'pr-10',
            error ? 'border-status-live' : 'border-surface-border',
            className,
          )}
          {...rest}
        />
        {endAdornment && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">{endAdornment}</div>
        )}
      </div>
      {error && <p className="mt-1 text-xs text-status-live">{error}</p>}
    </div>
  );
}